import { useEffect } from "react";
import DiscountProduct from "../../components/discountProduct/discountProduct";
import useGetData from "../../hook/getData";
import { GetProducts } from "../../services/client/products/getProducts";

const Discount = () => {
    const { data: Products } = useGetData(['products'], GetProducts)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="container py-5">
                {Products?.hasDiscountProducts ? (
                    <div className="row gy-4">
                        {Products?.hasDiscountProducts?.map((product: any) => (
                            <div className="col-md-3" key={product.id + 'newProduct'}>
                                <DiscountProduct slug={product.slug} name={product.name} primary_image={product.primary_image} description={product.description} quantity_check={product.quantity_check} />
                            </div>
                        ))}
                    </div>
                ) : null}
            </section>
        </>
    )
}

export default Discount;